<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 雁阵系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>平台信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="请输入平台名称" class="handle-input mr10"></el-input>
				<el-select v-model="query.status" placeholder="请选择状态" filterable>
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select> &nbsp;
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="平台名称"></el-table-column>
                <el-table-column prop="limit" label="单个账号发布限制"></el-table-column>
				<el-table-column prop="loginUrl" label="登录页面" width = "400"></el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
                        {{scope.row.status==0?"已激活":"未激活"}}
                    </template>				
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-open"
                            @click="handleActive(scope.$index, scope.row)"
							v-if="scope.row.status==1"
                        >激活</el-button>
						<el-button
                            type="text"
                            icon="el-icon-turn-off"
                            @click="handleNoActive(scope.$index, scope.row)"
							v-if="scope.row.status==0"
                        >停用</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="150px" :rules="rules">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="基本信息" name="baseTab">
						<el-form-item label="平台名称" prop="name">
							<el-input v-model="form.name"> </el-input>
						</el-form-item>
						<el-form-item label="单个账号发布限制" prop="limit">
							<el-input v-model="form.limit"> </el-input>
						</el-form-item>
						<el-form-item label="登录页面" prop="loginUrl">
							<el-input v-model="form.loginUrl"> </el-input>
						</el-form-item>
						<el-form-item label="管理页面" prop="manageUrl">
							<el-input v-model="form.manageUrl"> </el-input>
						</el-form-item>
						<el-form-item label="发布页面" prop="publishUrl">
							<el-input v-model="form.publishUrl"> </el-input>
						</el-form-item>
						<el-form-item label="备注" prop="remark">
							<el-input type=textarea :rows=5 v-model="form.remark"> </el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="登录步骤" name="loginTab">
						<el-input type=textarea :rows=19 v-model="form.loginStep"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="登出步骤" name="logoutTab">
						<el-input type=textarea :rows=19 v-model="form.logoutStep"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="管理步骤" name="manageTab">
						<el-input type=textarea :rows=19 v-model="form.manageStep"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="发布步骤" name="publishTab">
						<el-input type=textarea :rows=19 v-model="form.publishStep"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="敏感词汇映射" name="sensitiveTab">
						<el-input type=textarea :rows=19 v-model="form.sensitiveMapping"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="供应商标签" name="supplierSignTab">
						<el-input type=textarea :rows=19 v-model="form.supplierSign"> </el-input>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
    </div>
</template>

<script>
import { fetchPromotionPlatformData, savePromotionPlatform, deletePromotionPlatform, getPromotionPlatform } from '../../../api/index';
export default {
    name: 'promotion-platform',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			title:"",
			rules: {
                name: [{ required: true, message: '请输入平台名称', trigger: 'blur' }],
				limit: [{ required: true, message: '请输入单个账号限制', trigger: 'blur' }],
				loginUrl: [{ required: true, message: '请输入登录页面', trigger: 'blur' }],
				manageUrl: [{ required: true, message: '请输入管理页面', trigger: 'blur' }],
				publishUrl: [{ required: true, message: '请输入发布页面', trigger: 'blur' }]
            },
			activeName:"baseTab",
			statusKV:[{"key":0, "value":"已激活"}, {"key":1, "value":"未激活"}],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchPromotionPlatformData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePromotionPlatform([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加平台信息";
			this.activeName = "baseTab"
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			this.title = "修改平台信息";
			this.activeName = "baseTab"
            getPromotionPlatform(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		handleActive(index, row) {
			this.changeStatus(row, 0);
		},
		handleNoActive(index, row) {
			this.changeStatus(row, 1);
		},
		changeStatus(row, status) {
			this.$set(row, 'status', status);
			savePromotionPlatform(row).then(res => {
				if (res.code == 0) {
					this.$message.success('操作成功！');
					this.getData();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					savePromotionPlatform(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
